import { styled } from '@mui/material';
import { Swiper } from 'swiper/react';

import { COLORS } from '~/styles/colors';

export const StyledSwiper = styled(Swiper)({
  width: '600px',

  '--swiper-pagination-bottom': 0,

  '& .swiper-pagination': {
    '& .swiper-pagination-bullet': {
      height: 4,
      width: 20,
      borderRadius: 2,
      background: COLORS.white,
      opacity: 0.4,
      marginInline: '6px !important',

      '&.swiper-pagination-bullet-active': {
        opacity: 1,
      },
    },
  },
});

export const StyledSlide = styled('div')({
  width: '600px',
  height: '600px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

interface StyledImageProps {
  mt?: string | number;
}
export const StyledImage = styled('img')<StyledImageProps>(({ mt }) => ({
  width: '579px',
  marginLeft: '21px',
  marginTop: mt,
}));

export const StyledTextContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  marginBottom: 34,
});
